<mat-list>
  <img class="loading" src="assets/images/loading.gif" alt="" fxLayoutAlign="center" *ngIf="isReportLoading" />
  <ng-container *ngFor="let report of reports">
    <mat-list-item *ngIf="report.reportId !== targetReport?.reportId" [class.isReportLoading]="isReportLoading">
      <a
        mat-list-item
        (click)="downloadPdf(report)"
        [class.selectable]="report.status === '000' || report.status === '400' || report.status === '900'"
        [disabled]="report.status === '500' || report.status === '600'"
      >
        <div class="list-content">
          <div class="icon-area">
            <mat-icon
              *ngIf="report.status === '000' || report.status === '400' || report.status === '900'"
              mat-list-icon
              class="pdf-icon pdf-icon-color"
              >picture_as_pdf</mat-icon
            >
            <mat-icon *ngIf="report.status === '500' || report.status === '600'" mat-list-icon class="pdf-icon update-icon-color">update</mat-icon>
          </div>
          <div class="item-list-area">
            <h4 mat-line [matTooltip]="report.title" matTooltipPosition="above" matTooltipClass="tooltip-overflow" style="margin: 0 !important">
              {{ report.title }}
            </h4>
            <div class="status-area">
              <div class="status editing flexible-box" *ngIf="report.status !== '900'">
                <mat-icon class="status-icon editing-icon">description</mat-icon> {{ "inspectionReportHistory.editing" | translate }}
              </div>
              <div class="status completed flexible-box" *ngIf="report.status === '900'">
                <mat-icon class="status-icon completed-icon">task</mat-icon> {{ "inspectionReportHistory.completed" | translate }}
              </div>
              <p class="date-label" mat-line>{{ report.lastUpdateDate | date: "yyyy/MM/dd" }}</p>
            </div>
          </div>
          <div class="menu-area">
            <button mat-icon-button class="more-vert-icon" [matMenuTriggerFor]="MatMenu" (click)="$event.stopPropagation()">
              <mat-icon class="open-list-item-menu">more_vert</mat-icon>
            </button>
            <mat-menu class="three-dot-menu" #MatMenu>
              <button
                mat-menu-item
                [disabled]="report.status === '500' || report.status === '600' || isDesktopAndOffline"
                (click)="downloadPdf(report)"
              >
                {{ "inspectionReportHistory.viewReport" | translate }}
              </button>
              <button mat-menu-item [disabled]="!canReuseData || isDesktopAndOffline" (click)="reuseEmit(report.reportId)">
                {{ "inspectionReportHistory.reuseData" | translate }}
              </button>
              <button mat-menu-item *ngIf="report.status === '900'" [disabled]="isDesktopAndOffline" (click)="openShareDialog(report)">
                {{ "inspectionReportHistory.share" | translate }}
              </button>
              <button
                mat-menu-item
                *ngIf="report.status !== '900' && report.status !== '600'"
                [disabled]="report.status === '500' || isDesktopAndOffline"
                (click)="shareDraftInspectionReportPdf(report)"
              >
                {{ "inspectionReportHistory.share" | translate }}
              </button>
            </mat-menu>
          </div>
        </div>
      </a>
    </mat-list-item>
  </ng-container>
  <div *ngIf="!reports || reports.length < 1" fxLayoutAlign="center">
    <p>{{ "inspectionReportHistory.noReportsFound" | translate }}</p>
  </div>
</mat-list>
